/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { useForm } from "../../../../provider/Form/FormProvider";
import { FormHeaderWrapper } from "../../Common/FormHeaderWrapper/FormHeaderWrapper";
import RadioGroupConfigured from "../../ConfiguredFormElements/RadioGroupConfigured/RadioGroupConfigured";
import AutocompleteSelectFieldConfigured from "../../ConfiguredFormElements/AutocompleteSelectFieldConfigured/AutocompleteSelectFieldConfigured";
import TextFieldConfigured from "../../ConfiguredFormElements/TextFieldConfigured/TextFieldConfigured";
import SingleSelectFieldConfigured from "../../ConfiguredFormElements/SingleSelectFieldConfigured/SingleSelectFieldConfigured";
import DateFieldConfigured from "../../ConfiguredFormElements/DateFieldConfigured/DateFieldConfigured";
import { ContractDetailsProps } from "../../../../types/ContractDetailsProps";
import { FormDataTypes } from "../../../../types/FormDataTypes";
import NumberFieldConfigured from "../../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";

export default function VehicleContractDetails({ submitProps }: ContractDetailsProps) {
  const { values, handleSubmit, setErrors }: FormDataTypes = useForm();
  const handleSubmitInternal = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!validateMileages(values)) {
      return;
    }
    handleSubmit(event);
  };

  const validateMileages = (values: Record<string, any>) => {
    if (values.currentMileage && values.mileageAtPurchase && parseInt(values.currentMileage, 10) < parseInt(values.mileageAtPurchase, 10)) {
      const errorText = "Der aktuelle Kilometerstand darf nicht kleiner sein als zum Kaufzeitpunkt. Bitte prüfen Sie Ihre Angaben.";
      setErrors({
        mileageAtPurchase: errorText,
        currentMileage: errorText,
      });
      return false;
    }
    return true;
  };

  return (
    <FormHeaderWrapper submitProps={submitProps} handleSubmit={handleSubmitInternal}>
      <RadioGroupConfigured caseData={values} fieldPath={"buyerOrSeller"} required />
      {values.buyerOrSeller && (
        <>
          <AutocompleteSelectFieldConfigured caseData={values} fieldPath={"vehicleMake"} />
          <TextFieldConfigured caseData={values} fieldPath={"model"} required />
          <TextFieldConfigured caseData={values} fieldPath={"vehicleId"} />

          {values.objectiveClient === "withdrawal" && (
            <>
              <NumberFieldConfigured caseData={values} fieldPath={"mileageAtPurchase"} required />
              <NumberFieldConfigured caseData={values} fieldPath={"currentMileage"} required />
            </>
          )}

          <NumberFieldConfigured caseData={values} fieldPath={"purchasePrice"} numberType={"float"} fieldType={"money"} required />
          <SingleSelectFieldConfigured caseData={values} fieldPath={"buyerPaidStatus"} required />
          <RadioGroupConfigured caseData={values} fieldPath={"locationOfGood"} required />
          <RadioGroupConfigured caseData={values} fieldPath={"hasDefects"} required />

          {values.hasDefects === "yes" && (
            <>
              <RadioGroupConfigured caseData={values} fieldPath={"isAccidentCar"} required />
              <DateFieldConfigured caseData={values} fieldPath={"defectsRecognitionDate"} required />
              <TextFieldConfigured caseData={values} fieldPath={"defectsDescriptionClient"} multiline />
              <SingleSelectFieldConfigured caseData={values} fieldPath={"numberRepairAttempts"} required />
              <SingleSelectFieldConfigured caseData={values} fieldPath={"numberReplacementAttempts"} required />
            </>
          )}
        </>
      )}
    </FormHeaderWrapper>
  );
}
